import { IconMapHome } from '@shared/icons'
import { Breadcrumb } from 'antd'
import cx from 'classnames'
import { length } from 'ramda'
import React from 'react'
import styled from 'styled-components'

type Props = {
  layers: any[] | undefined
  onClick?: (layer: any) => void
  addonAfter?: React.ReactNode
  addonBefore?: React.ReactNode
}

export default function BreadcrumbComponent({
  layers,
  onClick,
  addonBefore,
  addonAfter,
}: Props) {
  return (
    <StyledBreadcrumbWrapper>
      {addonBefore}
      <StyledBreadcrumb separator=">">
        {layers &&
          layers.map((layer: any, idx: number) => (
            <Breadcrumb.Item
              className={cx('ant-breadcrumb-link cursor-pointer', {
                disabled: !layer.hasPermission,
              })}
              onClick={() => layer.hasPermission && onClick && onClick(layer)}
              key={idx}>
              {idx === 0 && (
                <IconMapHome
                  className="anticon"
                  color={
                    length(layers) === 1
                      ? '#20E4FF'
                      : 'rgba(255, 255, 255, 0.5)'
                  }
                />
              )}
              <span className="notranslate">{layer.name}</span>
            </Breadcrumb.Item>
          ))}
      </StyledBreadcrumb>
      {addonAfter}
    </StyledBreadcrumbWrapper>
  )
}

const StyledBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 500;
  width: 100%;
  background-color: rgba(27, 29, 29, 0.9);
  padding: 1px 16px !important;
  font-size: 14px !important;
  min-height: 34px;
  pointer-events: auto;
`

const StyledBreadcrumb = styled(Breadcrumb)`
  ol li {
    color: rgba(255, 255, 255, 0.5) !important;
    font-size: 14px;
    font-weight: 500;

    > .ant-breadcrumb-separator {
      color: rgba(255, 255, 255, 0.5) !important;
    }

    &:last-child > span {
      color: #20e4ff;
      font-size: 14px;
      font-weight: 600;
    }

    .disabled {
      cursor: not-allowed !important;
      opacity: 0.65;
    }
  }
`
